import { connect } from 'react-redux'

import ContentHeader from './ContentHeader'
import { handleToggleNavigationSidebar } from '../../store/appReducer'

const mapActionCreators = {
  handleToggleNavigationSidebar,
}

const mapStateToProps = state => ({
  sidebarIsCollapsed: state.app.sidebarIsCollapsed,
})

export default connect(
  mapStateToProps,
  mapActionCreators
)(ContentHeader)



// WEBPACK FOOTER //
// ./src/legacy/containers/ContentHeader/container.jsx